import {
  ADFORM_PUSH,
  ADFORM_PUSH_FAILED,
  ADFORM_PUSH_SUCCESS,
  GOOGLE_ADS_PUSH,
  GOOGLE_ADS_PUSH_SUCCESS,
  GOOGLE_ADS_PUSH_FAILED,
  TTD_PUSH,
  TTD_PUSH_SUCCESS,
  TTD_PUSH_FAILED,
  TTD_CLEAR_ERROR_STATE,
  XANDR_PUSH,
  XANDR_PUSH_SUCCESS,
  XANDR_PUSH_FAILED
} from "../actions/platforms/constants";

const initialState = {
  isLoading: false,
  error: "",
  // googleAdsResponseMessage: "",
  successResponseMessage: "",
  ttdError: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ADFORM_PUSH:
    case GOOGLE_ADS_PUSH:
    case XANDR_PUSH:
      return {
        ...state,
        isLoading: true,
        error: "",
        successResponseMessage: ""
      };

    case ADFORM_PUSH_SUCCESS:
    case GOOGLE_ADS_PUSH_SUCCESS:
    case XANDR_PUSH_SUCCESS:
      return {
        ...state,
        successResponseMessage: action.payload,
        isLoading: false,
        error: ""
      };

    case ADFORM_PUSH_FAILED:
    case GOOGLE_ADS_PUSH_FAILED:
    case XANDR_PUSH_FAILED:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
        successResponseMessage: ""
      };

    case TTD_PUSH:
      return {
        ...state,
        isLoading: true,
        successResponseMessage: "",
        ttdError: null
      };

    case TTD_PUSH_FAILED:
      return {
        ...state,
        isLoading: false,
        successResponseMessage: "",
        ttdError: action.payload
      };

    case TTD_PUSH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        successResponseMessage: action.payload,
        ttdError: null
      };

    case TTD_CLEAR_ERROR_STATE:
      return {
        ...state,
        isLoading: false,
        successResponseMessage: "",
        ttdError: null
      };

    default:
      return state;
  }
};
